<template>
  <swiper
    :class="[
      'product-nav-slider',
      swiperInfo.type === 'imagevideo' && 'box-align',
    ]"
    :observer="true"
    :observeParents="true"
    :spaceBetween="swiperInfo.spaceBetween"
    :slidesPerView="swiperInfo.slidesPerView"
    :navigation="{
      nextEl: `.${swiperInfo.type}-${swiperInfo.page}-next`,
      prevEl: `.${swiperInfo.type}-${swiperInfo.page}-prev`,
    }"
  >
    <swiper-slide v-for="(item, i) in list" :key="i" style="min-width:80px">
      <div
        class="nav-slide-item d-flex justify-content-center align-items-center upload-list overflow-hidden"
        :style="{
          height:
            swiperInfo.page == 'equipdetail' && swiperInfo.type == 'imagevideo'
              ? '30rem'
              : swiperInfo.page == 'equipdetail' &&
                swiperInfo.type == 'document'
              ? '3.5rem'
              : '5rem',
              minWidth:'80px'
        }"
      >
        <img
          :src="item.url"
          alt=""
          class="img-fluid d-block w-100"
          v-if="
            swiperInfos.type === 'image' ||
            (swiperInfo.type == 'imagevideo' && isImg(item.object_name))
          "
        />
        <video
          v-if="
            swiperInfos.type === 'video' ||
            (swiperInfo.type == 'imagevideo' &&
              /\.(mp4|mov)$/.test(suffixName(item.object_name)))
          "
          :src="item.url"
          style="width: 100%; height: 100%"
          :id="`video-${i}`"
        ></video>
        <template v-if="['document', 'before', 'after', 'actual'].includes(swiperInfos.type)">
          <img v-if="isImg(item.object_name)" :src="item.url" alt="" class="img-fluid d-block w-100"/>
          <div v-else class="avatar-title bg-white text-secondary h-100"><i class="ri-file-text-line fs-36"></i></div>
        </template>

        <span class="upload-list__item-actions">
          <span
            v-for="(act, index) in swiperInfo.actionsClass"
            :key="index"
            :class="[
              index < swiperInfo.actionsClass.length - 1 && act.me,
              act.fs,
              item.is_collection && act.action == 'collect' && 'collectClass',
            ]"
          >
            <i
              :class="act.name"
              @click="
                handleActionClick($event, act.action, i, swiperInfos.type, item)
              "
            ></i>
          </span>
        </span>
      </div>
      <div v-if="nameType" class="text-center mt-1" style="min-width: 80px;white-space: break-spaces;">
        {{ filterName(item.object_name || item.originName) }}
      </div>
    </swiper-slide>
  </swiper>
  <div
    v-show="list.length&&nextfalse"
    :class="`swiper-button-next ${swiperInfo.type}-${swiperInfo.page}-next`"
  ></div>
  <div
    v-show="list.length&&nextfalse"
    :class="`swiper-button-prev ${swiperInfo.type}-${swiperInfo.page}-prev`"
  ></div>
</template>
<script>
import Swal from "sweetalert2";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation } from "swiper";
SwiperCore.use([Navigation]);
// import { deleteFile} from "@/service/index";
import { getUploadFileSign, documentCollection } from "@/service/index";
import { ElMessage } from "element-plus";

export default {
  emits: ["deleteFile", "editFile"],
  props: {
    nameType:{
      type:Boolean,
      default:true
    },
    swiperInfo: {
      type: Object,
      default: () => {
        return {
          type: "image",
          page: "modeltag",
          spaceBetween: 10,
          slidesPerView: 15,
          actionsClass: [
            { name: "ri-eye-fill", action: "view" },
            { name: "ri-download-2-fill", action: "download" },
            { name: "ri-delete-bin-5-fill", action: "delete" },
            { name: "ri-heart-fill", action: "collect" },
          ],
        };
      },
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    nextfalse:{
      type:Boolean,
      default:()=>{
        return true
      }
    }
  },
  data() {
    return {
      showPreviewImg: false,
      src: null,
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    swiperInfos() {
      return this.swiperInfo;
    },
  },
  methods: {
    // 是否图片
    isImg(path){
      return /\.(png|jpeg|jpg|gif)$/.test(path)
    },
    /* 是否是3d文件 */
    is3D(path){
      return /\.(mov|glb|ply|stl|xyz|off|dae|obj)$/.test(path)
    },
    filterName(name) {
      if (/^(device\/)/.test(name)) {
        return name.substring(44);
      } else if (/^(reports\/)/.test(name)) {
        return name.substring(45);
      } else if (/^(events\/)/.test(name)) {
        return name.substring(44);
      } else {
        return name;
      }
    },
    suffixName(name) {
      return name.substring(name.lastIndexOf("."));
    },
    play(i) {
      let curVideo = document.getElementById(`video-${i}`);
      curVideo.play();
      if (curVideo.requestFullscreen) {
        curVideo.requestFullscreen();
      } else if (curVideo.mozRequestFullScreen) {
        curVideo.mozRequestFullScreen();
      } else if (curVideo.webkitRequestFullscreen) {
        curVideo.webkitRequestFullscreen();
      } else if (curVideo.msRequestFullscreen) {
        curVideo.msRequestFullscreen();
      }
    },
    handleActionClick(ev, action, i, type, item) {
      if (action == "play") {
        this.play(i);
      }
      if (action == "delete") {
        Swal.fire({
          title: this.$t("base.delete_alert_title"),
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#f46a6a",
          cancelButtonText: this.$t("base.cancel"),
          confirmButtonColor: "#34c38f",
          confirmButtonText: this.$t("base.confirm"),
        }).then((result) => {
          if (result.isConfirmed) {
            /* 删除模型问题 */ 
            /* 由于数据可能是3d数据，因此type需要优先判断是非image非video非document，将type改为3d方便删除文件 */
            if( this.swiperInfos.type == 'document'&& (this.is3D(item.object_name)) ){
              type = '3d'
            }
            this.$emit("deleteFile", i, type);
            /*  deleteFile({object: item.object_name,}).then(res=>{
              if(res.result && res.result == 'OK'){
                this.$emit("deleteFile",i,type)
              }
            }).catch(err=>{
              Swal.fire(
                err ||"删除失败!"
              );
            }) */
          }
        });
      }
      if (action == "view") {
        if (
          type == "image" ||
          (type == "imagevideo" && this.isImg(item.object_name || item.originName))
        ) {
          this.$preview(item.url);
        } else if (
          type == "imagevideo" &&
          /\.(mp4|mov)$/.test(
            this.suffixName(item.object_name || item.originName)
          )
        ) {
          this.play(i);
        } else {
          let suffix = this.suffixName(item.object_name || item.originName);
          let a = document.createElement("a");
          a.innerHTML = item.object_name || item.originName;
          var itemlist = [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx"];
          if (itemlist.includes(suffix)) {
            // a.href = `http://view.officeapps.live.com/op/view.aspx?src=${item.url}`;
            a.href = `http://view.xdocin.com/xdoc?_xdoc=${item.url}`;
          } else {
            a.href = item.url;
          }
          a.target = "_blank";
          a.click();
        }
      }

      if (action == "download") {
        this.downloadFileSign(item.object_name || item.originName);
      }
      if (action == "edit") {
        this.$emit("editFile");
      }
      if (action == "collect") {
        let params = {
          document_id: item.document_id,
          is_collect: !item.is_collect,
        };
        documentCollection(params).then((res) => {
          console.log(res);
          ElMessage.success(this.$t("base.operate_success"));
          this.list.map((a) => {
            if (a.document_id == item.document_id) {
              a.is_collection = !a.is_collection;
            } else {
              a.is_collection = false;
            }
          });
        });
      }
    },
    saveAs(data, name) {
      const urlObject = window.URL || window.webkitURL || window;
      const export_blob = new Blob([data]);
      const save_link = document.createElement("a");
      save_link.href = urlObject.createObjectURL(export_blob);
      save_link.download = name;
      save_link.click();
    },

    downloadFileSign(objectName) {
      Swal.fire({ title: this.$t("下载中"), showConfirmButton: false });
      Swal.showLoading();
      setTimeout(() => {
        let params = {
          object: objectName,
          method: "download",
        };
        getUploadFileSign(params)
          .then((res) => {
            if (res && res.payload) {
              const url2 = res.payload.signedUrl.replace(/\\/g, "/");
              const xhr = new XMLHttpRequest();
              xhr.open("GET", url2, true);
              xhr.responseType = "blob";
              xhr.onload = () => {
                if (xhr.status === 200) {
                  this.saveAs(xhr.response, this.filterName(objectName));
                }
              };
              xhr.send();
              Swal.close();
            }
          })
          .catch((err) => {
            Swal.close();
            Swal.fire(err || this.$t("page.download-failed-please-try-again"));
          });
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.box-align {
  top: 50%;
  transform: translate(0, -50%);
  // transform: translate(0%,20%);
}
.upload-list .upload-list__item-actions:hover {
  opacity: 1;
  span {
    display: inline-block;
  }
}
.upload-list .upload-list__item-actions:after {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}
.upload-list {
  position: relative;
  .upload-list__item-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 0.25rem;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    span {
      display: none;
      cursor: pointer;
      :hover {
        color: #6691e7;
      }
    }
  }
}
.collectClass {
  color: #6a93e4;
}

</style>
